import { ApiError, errorMessage } from "@/lib/http";

import { Alert } from "./Alert";
import { useFormContext } from "./Form";

/**
 * An API error, with the request id support will ask for (unless `hideRequestId`: the message alone).
 * Inside a `<Form>` whose error summary already lists this error's field errors, it renders nothing.
 */
export function ErrorAlert({ error, hideRequestId = false }: { error: unknown; hideRequestId?: boolean }) {
  const form = useFormContext();
  if (!error || form?.covers(error)) return null;
  const requestId = error instanceof ApiError && !hideRequestId ? error.requestId : null;
  const retryAfter = error instanceof ApiError && error.status === 429 ? error.retryAfterSeconds : null;
  return (
    <Alert tone="danger">
      {errorMessage(error).replace(/([^.!?])$/, "$1.")}
      {retryAfter !== null &&
        ` Try again in ${retryAfter < 90 ? `${retryAfter} seconds` : `${Math.ceil(retryAfter / 60)} minutes`}.`}
      {requestId && <span className="mt-1 block font-mono text-xs opacity-70">Request ID: {requestId}</span>}
    </Alert>
  );
}
